import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CheckHeart = function CheckHeart(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9 11 2 2 4.5-4.5m-3.5068-3.3642C9.9938 2.7984 6.6598 2.1696 4.1547 4.31s-2.8577 5.719-.8905 8.2504c1.4859 1.912 5.707 5.7506 7.6838 7.5145.3634.3242.5451.4864.7578.5502.1847.0554.39.0554.5747 0 .2127-.0638.3944-.226.7578-.5502 1.9767-1.7639 6.1979-5.6025 7.6838-7.5145 1.9672-2.5314 1.6576-6.1325-.8905-8.2504-2.5481-2.1178-5.8391-1.5116-7.8384.8258"
    })
  }));
};
export default CheckHeart;